import { InjectionToken } from '@angular/core';

/** Enables the "Create account" option on the login page. Off unless an app provides `true`. */
export const CREATE_ACCOUNT_ENABLED = new InjectionToken<boolean>('CREATE_ACCOUNT_ENABLED', {
  providedIn: 'root',
  factory: () => false,
});
